import React from "react";
import { Link } from "react-router-dom";

import authUtil from "utils/auth";

const LoginButton = (
  <div className="navbar-item">
    <div className="navbar-item">
      <a
        className="button is-success"
        onClick={() => {
          authUtil.login();
        }}
      >
        <span>Login</span>
        <span className="icon is-small">
          <i className="fas fa-sign-in-alt" />
        </span>
      </a>
    </div>
  </div>
);

const DashboardButton = (
  <div className="navbar-item">
    <div className="navbar-item">
      <Link className="button" to="/dashboard">
        <span>Dashboard</span>
        <span className="icon is-small">
          <i className="fas fa-chart-line" />
        </span>
      </Link>
    </div>
  </div>
);

export default () => (
  <nav className="navbar is-info">
    <div className="navbar-brand">
      <Link to="/dashboard" className="navbar-item">UTBA Superuser Panel</Link>
    </div>
    <div className="navbar-menu is-hidden-touch">
      <div className="navbar-end">{authUtil.isTokenValid() ? DashboardButton : LoginButton}</div>
    </div>
    <div className="navbar-menu is-active is-hidden-desktop">
      {authUtil.isTokenValid() ? DashboardButton : LoginButton}
    </div>
  </nav>
);



// WEBPACK FOOTER //
// ./src/pages/Home/Nav.js